/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "subject2";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface VisualSource {
}

export enum VisualSource_Enum {
  INVALID = 0,
  EO = 1,
  IR = 2,
  AUTO = 4,
  UNRECOGNIZED = -1,
}

export function visualSource_EnumFromJSON(object: any): VisualSource_Enum {
  switch (object) {
    case 0:
    case "INVALID":
      return VisualSource_Enum.INVALID;
    case 1:
    case "EO":
      return VisualSource_Enum.EO;
    case 2:
    case "IR":
      return VisualSource_Enum.IR;
    case 4:
    case "AUTO":
      return VisualSource_Enum.AUTO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return VisualSource_Enum.UNRECOGNIZED;
  }
}

export function visualSource_EnumToJSON(object: VisualSource_Enum): string {
  switch (object) {
    case VisualSource_Enum.INVALID:
      return "INVALID";
    case VisualSource_Enum.EO:
      return "EO";
    case VisualSource_Enum.IR:
      return "IR";
    case VisualSource_Enum.AUTO:
      return "AUTO";
    case VisualSource_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseVisualSource(): VisualSource {
  return {};
}

export const VisualSource = {
  encode(_: VisualSource, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): VisualSource {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseVisualSource();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): VisualSource {
    return {};
  },

  toJSON(_: VisualSource): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<VisualSource>, I>>(base?: I): VisualSource {
    return VisualSource.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<VisualSource>, I>>(_: I): VisualSource {
    const message = createBaseVisualSource();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
